import SvgIcon from '@/components/SvgIcon';

// 海外代购注意事项
const articleList = [
  '<span class="text-[#FF4960]">因关税政策变化，您购买的商品下单后根据货物的产地不同需要支付关税（以货物报关实时关税为准）, 您应在收到立创商城工作人员通知后 2个工作日内支付完毕，若逾期支付, 立创商城有权取消您的订单，已支付货款作为违约金不予退还，若违约金无法弥补立创商城损失的，立创商城有权要求您继续补足。</span>',
  '海外代购（Texas Instruments、Mouser、Digikey、Avnet美国、Avnet欧洲、Avnet亚洲、Future、V、E、 RS Components、Bürklin、A、Master、TME、CoreStaff、Rutronik、TTI、Questcomp、Powell、Sager、Chip1stop、E_uk、Heilind）物料暂不提供商品类目、品牌、封装规格、包装等筛选功能，请以物料的实际参数为准。',
  '海外代购数据来源于供应商，基本保证实时更新，但不排除因网络或供应商网站本身数据问题导致产品库存或价格产生变化，请在下单后尽快支付。 ',
  '立创商城海外代购服务免国际邮费，如果部分型号因采购数量过多、体积较大或重量较重等原因出现超重时，视供应商不同可能需要补交超出部分的运费。',
  '部分商品（如继电器、带通滤波器、衰减器、各类模块、线缆等）<span class="text-[#FF4960]">可能需要增收3%-30%的关税</span>；开关、保险丝、气体放电管、连接器、电池等需要商检和3C认证费用。<span class="text-[#FF4960]">商检费用为100元/型号；3C认证费用会根据报关型号平摊</span>，若只有单个型号费用为100元。如有疑问，可联系客服人员进行解答。',
  '因货期、库存等不确定因素，海外代购渠道的商品，无法与自营库存渠道的商品一起下单，请分开提交订单。',
  '代购渠道中Texas Instruments不承诺批次和包装，除Texas Instruments外的其他海外代购物料基本默认批次为5年内，如有特殊要求，请先咨询客服。',
  '受供应商库存影响，个别代购物料可能会出现发货供应商变动的情况，如介意请在订单备注中说明。',
  '海外代购订单下单完成支付后，不支持取消订单退款退货，请知悉。',
  '海外代购物料不影响功能使用的部分瑕疵问题的售后政策以海外供应商为准。如有售后问题，您必须提供随货供应商原标签才能受理。【注意】请您收到货物后妥善保管好货物原标签，货物标签是协调售后的关键凭据，如有遗失、将无法受理。',
  '海外代购商品存在出口审核、限购、无法报关等不确定因素，若因限购或报关等不可抗因素导致交期延期或订单取消等情况，商城客服将第一时间通知客户，联系客户处理，商城不承担由此而导致的任何直接和间接损失。',
];

export default function OverseasNotice() {
  return (
    <section className="mb-[20px] rounded-[10px] bg-[#fff] p-[23px_21px_17px] text-[12px] text-[#444]">
      <div className="item-center mb-[19px] flex">
        <SvgIcon app="so" iconName="notice" className="mr-[6px] size-[20px]"></SvgIcon>
        <strong>注意事项：</strong>
      </div>
      <ul>
        {articleList.map((item, index) => (
          <OverseasNoticeItem key={index} index={index + 1} content={item}></OverseasNoticeItem>
        ))}
      </ul>
    </section>
  );
}

function OverseasNoticeItem({ index, content }) {
  return (
    <li className="mb-[19px] flex">
      <span className="mr-[6px] size-[20px] shrink-0 rounded-[10px] bg-[#f1f1f1] text-center text-[12px] leading-[20px] text-[#444]">
        {index}
      </span>
      <p className="leading-[20px]" dangerouslySetInnerHTML={{ __html: content }}></p>
    </li>
  );
}
